import { useEffect } from 'react'
import consumer from '../../../../../cable/cable'

export const useCableSubscription = (
  channel: string,
  game: number,
  onReceiveData: (data: any) => void,
  onConnected: () => void = () => {}
) => {
  useEffect(() => {
    const subs = consumer.subscriptions.create(
      {
        channel: channel,
        game: game,
      },
      {
        connected: onConnected,
        disconnected: () => {},
        received: (data: string) => {
          onReceiveData(JSON.parse(data))
        },
      }
    )
    return () => {
      consumer.subscriptions.remove(subs)
      consumer.disconnect()
    }
  }, [])
}
